module.exports = __webpack_public_path__ + "img/HNYT087_12.54b5bcab.gif";